import {message} from '@sail/intl';

export const sectionTitle = message({
  id: 'mkt-ssr.startup_partners.benefits.sectionTitle',
  defaultMessage: 'Your exclusive benefits',
  description: 'Benefits Overview Section Title',
});

export const waivedProcessingFeeDescription = message<{
  waivedProcessingFee: string;
}>({
  id: 'mkt-ssr.startup_partners.benefits.waivedProcessingFeeDescription',
  defaultMessage:
    'Waived fees on your next {waivedProcessingFee} in Stripe processing',
  description:
    'Waived Processing of X amount if Startup decides to join Stripe.',
});

export const waivedProcessingAmountDescription = message<{
  waivedProcessingAmount: string;
  creditAmount: string;
}>({
  id: 'mkt-ssr.startup_partners.benefits.waivedProcessingAmountDescription',
  defaultMessage:
    '{creditAmount} in credits to offset fees for Stripe Payments, Connect, Billing, and more. In countries where credits are not yet available, you’ll get waived fees on the equivalent of {waivedProcessingAmount} in processing volume',
  description:
    'Waived Processing of X amount if Startup decides to join Stripe.',
});

export const firstYearFree = message({
  id: 'mkt-ssr.startup_partners.benefits.firstYearFree',
  defaultMessage:
    'First year free for all major products: Stripe Connect, Radar, and Sigma (new Stripe users only)',
  description:
    'First year free for major products if startup decides to join Stripe.',
});

export const eligibleForCustomPricing = message<{eligibleMMRTarget: string}>({
  id: 'mkt-ssr.startup_partners.benefits.eligibleForCustomPricing',
  defaultMessage:
    'Eligible for a custom pricing review (at {eligibleMMRTarget} MRR for 2+ months)',
  description: 'Eligible for custom pricing if startup decides to join Stripe.',
});

export const aPricingReview = message<{eligibleMMRTarget: string}>({
  id: 'mkt-ssr.startup_partners.benefits.aPricingReview',
  defaultMessage:
    'A pricing review when you hit {eligibleMMRTarget} MRR for 3 consecutive months',
  description: 'Eligible for custom pricing if startup decides to join Stripe.',
});

export const accessToExclusiveEvents = message({
  id: 'mkt-ssr.startup_partners.benefits.accessToExclusiveEvents',
  defaultMessage: 'Access to exclusive Stripe events and product previews',
  description: 'Access to exclusive events if startup decides to join Stripe.',
});

export const exclusiveEvents = message({
  id: 'mkt-ssr.startup_partners.benefits.exclusiveEvents',
  defaultMessage:
    'Exclusive events to build your network of founders and Stripe leaders',
  description: 'Access to exclusive events if startup decides to join Stripe.',
});

export const prioritySupport = message({
  id: 'mkt-ssr.startup_partners.benefits.prioritySupport',
  defaultMessage:
    'Priority support, guaranteeing faster SLAs for your business',
  description:
    'Startup will receive priority support if they decides to join Stripe.',
});

export const discountedAtlasIncorporation = message({
  id: 'mkt-ssr.startup_partners.benefits.discountedAtlasIncorporation',
  defaultMessage: 'Discounted Stripe Atlas incorporation',
  description:
    'Startup will receive discounted Atlas incorporation if they join Stripe.',
});

export const expertInsightsAndProgramming = message({
  id: 'mkt-ssr.startup_partners.benefits.expertInsightsAndProgramming',
  defaultMessage:
    'Expert insights and programming to support your learning and growth',
  description: 'Startup will receive expert insights and programming',
});

export const guidanceOnIntegrations = message({
  id: 'mkt-ssr.startup_partners.benefits.guidanceOnIntegrations',
  defaultMessage:
    'Guidance on integrations, no-code options, and third-party tools to reduce decision fatigue',
  description:
    'Startup will receive Guidance on integrations, no-code options, and third-party tools',
});

export const offerAvailableToNewStripeUsersOnly = message({
  id: 'mkt-ssr.startup_partners.benefits.offerAvailableToNewStripeUsersOnly',
  defaultMessage: 'Offer available to new Stripe users only',
  description: 'Offer available to new Stripe users only',
});

export const faqCta = message({
  id: 'mkt-ssr.startup_partners.benefits.faqCta',
  defaultMessage: 'See program eligibility and credits FAQs',
  description: 'Link copy',
});
